var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.data && _vm.params.data.is_active)?_c('v-icon',{staticClass:"mr-4 green--text"},[_vm._v(" mdi-check-circle ")]):_c('v-icon',{staticClass:"mr-4 red--text"},[_vm._v("mdi-close-circle")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }